import { createSlice } from '@reduxjs/toolkit';
import FJTextToImageDataConfig from '../../config/dataConfig/FJTextToImageDataConfig';
import FJTextToImageConstant from '../../constants/FJTextToImageConstant';
import FJConstant from '../../constants/FJConstant';
import FJCommunityUtil from '../../util/FJCommunityUtil';
import { PUBLISH_TYPE } from '../../config/dataConfig/FJCommunityData';
const defaultModelConfig = FJTextToImageDataConfig.MODELS[2];
export const FJSliceTextToImage = createSlice({
    name: 'textToImage',
    initialState: {
        prompt: '',
        curStyle: {
            value: '',
            name: 'none',
            previewImg: 'none.jpg',
        },
        curModel: defaultModelConfig.value,
        curRatio: defaultModelConfig.supportRatios[0],
        generateNumber: localStorage.getItem('generateNumber')
            ? Number(localStorage.getItem('generateNumber'))
            : FJTextToImageDataConfig.IMAGE_NUMBER_LIST[0].value,
        promptStatus: FJTextToImageConstant.NORMAL,
        curResolution: '1K',
        promptMaxLength:
            FJTextToImageDataConfig.MODELS[0]?.promptCharacterLimit || FJTextToImageDataConfig.PROMPT_TEXT_LIMIT,

        styleList: [],
        curGeneratingPromptImageUrl: '/public/img/textToImage/styles/test.jpg',

        inspireList: [],
        presetImageList: [],
        isShowPresetImageBox: true,

        // 图片上传相关状态
        uploadImageInfo: {},
        uploadImages: [],
        uploadStatus: FJConstant.DEFAULT, // default, loading, success, error
        // 是否是提示词上传
        isPrompt: false,

        privacyStatus: FJCommunityUtil.getLocalStoragePrivacyStatus() || PUBLISH_TYPE.ONLY_PUBLIC,
        creationList: [],
        taskStatus: FJConstant.DEFAULT,
        isDone: false, // AI工具已经加工完成并返回了数据
        freeNumCreation: 0,
    },
    reducers: {
        setSliceFreeNumCreationAction: (state, action) => {
            state.freeNumCreation = action.payload;
        },
        setSliceCreationListAction: (state, action) => {
            if (!action.payload) return;
            const isLoading = action.payload.filter(i => i.isLoading).length !== 0;
            const isFailed = action.payload.filter(i => i.isReload).length !== 0;
            state.creationList = action.payload;
            state.isDone = action.payload.length > 0 && !isLoading && !isFailed;
            if (state.isDone) state.selectedDownloadList = action.payload;
        },
        setSliceIsDoneAction: (state, action) => {
            state.isDone = action.payload;
        },
        setSliceTaskStatusAction: (state, action) => {
            state.taskStatus = action.payload;
        },
        setSelectedDownloadList: (state, action) => {
            state.selectedDownloadList = action.payload;
        },

        setSlicePrompt: (state, action) => {
            state.prompt = action.payload;
        },
        setSlicePromptStatus: (state, action) => {
            state.promptStatus = action.payload;
        },
        setSliceStyle: (state, action) => {
            state.curStyle = action.payload;
        },
        setSliceModel: (state, action) => {
            state.curModel = action.payload;
        },
        setSliceRatio: (state, action) => {
            state.curRatio = action.payload;
        },
        setSliceGenerateNumber: (state, action) => {
            state.generateNumber = action.payload;
        },
        setSliceStyleList: (state, action) => {
            state.styleList = action.payload;
        },
        setSliceCurGeneratingPromptImageUrl: (state, action) => {
            state.curGeneratingPromptImageUrl = action.payload;
        },
        setSliceUploadImageInfo: (state, action) => {
            state.uploadImageInfo = action.payload;
        },
        setSliceUploadStatus: (state, action) => {
            state.uploadStatus = action.payload;
        },
        setSliceInspireList: (state, action) => {
            state.inspireList = action.payload;
        },
        setSlicePresetImageList: (state, action) => {
            state.presetImageList = action.payload;
        },
        setSliceIsShowPresetImageBox: (state, action) => {
            state.isShowPresetImageBox = action.payload;
        },
        setSliceIsPrompt: (state, action) => {
            state.isPrompt = action.payload;
        },
        setSliceResolution: (state, action) => {
            state.curResolution = action.payload;
        },
        setSliceUploadImages: (state, action) => {
            state.uploadImages = action.payload;
        },
        removeUploadImages: (state, action) => {
            const index = action.payload;
            state.uploadImages.splice(index, 1);
        },
        addUploadImages: (state, action) => {
            state.uploadImages.push(action.payload);
        },
        setSlicePromptMaxLength: (state, action) => {
            state.promptMaxLength = action.payload;
        },
        setSlicePrivacySettingAction: (state, action) => {
            state.privacyStatus = action.payload;
            FJCommunityUtil.setLocalStoragePrivacyStatus(action.payload);
        },
    },
});

export const {
    setSlicePrompt,
    setSlicePromptStatus,
    setSliceStyle,
    setSliceModel,
    setSliceRatio,
    setSliceGenerateNumber,
    setSliceStyleList,
    setSliceCurGeneratingPromptImageUrl,
    setSliceInspireList,
    setSlicePresetImageList,
    setSliceIsShowPresetImageBox,
    setSliceUploadImageInfo,
    setSliceUploadStatus,
    setSliceIsPrompt,
    setSliceResolution,
    setSliceUploadImages,
    removeUploadImages,
    addUploadImages,
    setSlicePromptMaxLength,
    setSlicePrivacySettingAction,
    setSelectedDownloadList,
    setSliceCreationListAction,
    setSliceIsDoneAction,
    setSliceTaskStatusAction,
    setSliceFreeNumCreationAction,
} = FJSliceTextToImage.actions;

export default FJSliceTextToImage.reducer;
